import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import PetsnapLogo from "@/components/PetsnapLogo";

export default function PaymentCancel() {
  return (
    <div className="min-h-screen bg-[#FDFBF7] paper-grain flex items-center justify-center p-6">
      <div className="max-w-md w-full text-center relative z-10">
        <PetsnapLogo className="w-14 h-14 mx-auto mb-6" />
        <XCircle className="w-14 h-14 text-[#6A606C] mx-auto mb-4" />
        <h1 className="font-display text-4xl font-bold text-[#2D232E]">No worries — no charge</h1>
        <p className="font-hand text-2xl text-[#E76F51] mt-2">come back anytime!</p>
        <p className="text-[#6A606C] mt-2">
          You cancelled the checkout. Your free plan is untouched.
        </p>
        <div className="flex items-center justify-center gap-2 mt-6">
          <Link
            to="/pricing"
            className="rounded-full bg-[#E76F51] hover:bg-[#F4A261] text-white font-semibold px-6 py-3 shadow-[0_8px_20px_rgba(231,111,81,0.25)]"
          >
            See plans again
          </Link>
          <Link
            to="/"
            className="rounded-full bg-white border border-[#EAE2D6] hover:border-[#E76F51] text-[#2D232E] font-semibold px-6 py-3"
          >
            Back home
          </Link>
        </div>
      </div>
    </div>
  );
}
